import { createMMKV } from 'react-native-mmkv';
import createJSONStorage from './jsonStorage';
import { StorageScope } from './types';
const deviceStorageOptions = {
    id: 'device',
};
const sessionStorageOptions = {
    id: 'session',
};
// ponytail: Proxy defers `createMMKV()` until first method use. New Arch can
// evaluate boot modules before Nitro/JSI is ready; eager create then throws
// "[runtime not ready]". Ceiling: Proxy breaks `instanceof` — callers use
// methods only.
function lazyInstance(create) {
    let instance;
    return new Proxy({}, {
        get(_target, prop) {
            if (prop === 'then')
                return undefined;
            instance ??= create();
            const value = Reflect.get(instance, prop, instance);
            return typeof value === 'function'
                ? value.bind(instance)
                : value;
        },
    });
}
const deviceNativeStorage = lazyInstance(() => createMMKV(deviceStorageOptions));
const sessionNativeStorage = lazyInstance(() => createMMKV(sessionStorageOptions));
export const getNativeStorage = (scope) => scope === StorageScope.DEVICE ? deviceNativeStorage : sessionNativeStorage;
export const UNSAFE_clearAllStorages = () => {
    getNativeStorage(StorageScope.DEVICE).clearAll();
    getNativeStorage(StorageScope.USER).clearAll();
};
const deviceJSONStorage = lazyInstance(() => createJSONStorage(deviceStorageOptions));
const sessionJSONStorage = lazyInstance(() => createJSONStorage(sessionStorageOptions));
export const getJSONStorage = (scope) => scope === StorageScope.DEVICE ? deviceJSONStorage : sessionJSONStorage;
